import { Grid } from "@material-ui/core";
import { get } from "lodash";
import { useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Country } from "../../../../../../../components/forms/country";
import { TextField } from "../../../../../../../components/forms/text";
import { countries } from "../../../../../../../store/common/models";

export function Address({
  path,
  errorPath,
}: {
  path: string;
  errorPath: string;
}) {
  const { t } = useTranslation("fields");
  const {
    register,
    setValue,
    control,
    formState: { errors, isSubmitted },
  } = useFormContext();

  const country = useWatch({ control, name: `${path}.country` });
  const onChangeCountry = useCallback(
    (x: typeof countries.T | null) =>
      setValue(`${path}.country`, x, {
        shouldValidate: isSubmitted,
      }),
    [setValue, isSubmitted]
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={t(`street-address`)}
          {...register(`${path}.streetAddress`)}
          error={!!get(errors, `${errorPath}.streetAddress`)}
          helperText={get(errors, `${errorPath}.streetAddress`)?.message}
        />
      </Grid>
      <Grid item xs={12} md={7}>
        <TextField
          fullWidth
          label={t(`city`)}
          {...register(`${path}.city`)}
          error={!!get(errors, `${errorPath}.city`)}
          helperText={get(errors, `${errorPath}.city`)?.message}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TextField
          fullWidth
          label={t(`zip`)}
          {...register(`${path}.zip`)}
          error={!!get(errors, `${errorPath}.zip`)}
          helperText={get(errors, `${errorPath}.zip`)?.message}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label={t(`state`)}
          {...register(`${path}.state`)}
          error={!!get(errors, `${errorPath}.state`)}
          helperText={get(errors, `${errorPath}.state`)?.message}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Country
          fullWidth
          label={t(`country`)}
          onChange={onChangeCountry}
          value={country}
          error={!!get(errors, `${errorPath}.country`)}
          helperText={get(errors, `${errorPath}.country`)?.message}
        />
      </Grid>
    </Grid>
  );
}
